import React from 'react';
import { DatabaseInstructionsMenu } from './DatabaseInstructionsMenu';
import accelerateLogo from '/assets/accelerate-logo.png';

interface DatabaseInstructionsPageProps {
  customerId?: string;
  onBack?: () => void;
}

export const DatabaseInstructionsPage: React.FC<DatabaseInstructionsPageProps> = ({ 
  customerId, 
  onBack 
}) => {
  return (
    <div className="min-h-screen bg-black text-white" style={{ backgroundColor: 'black' }}>
      {/* Header */}
      <header className="bg-black text-white shadow-sm" style={{ borderBottom: '2px solid var(--caylent-light-green)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <div className="w-12 h-12 mr-3 flex items-center justify-center">
                <img 
                  src={accelerateLogo} 
                  alt="Caylent Accelerate" 
                  className="w-full h-full object-contain"
                />
              </div>
              <h1 className="caylent-small-title text-white" style={{ color: 'white' }}>
                Database Export Instructions
              </h1>
              {customerId && (
                <span 
                  className="ml-4 px-3 py-1 rounded-full caylent-body-small"
                  style={{ 
                    backgroundColor: 'var(--caylent-light-green)', 
                    color: 'var(--caylent-dark-green)',
                    fontSize: '10px',
                    fontWeight: '500'
                  }}
                >
                  Customer: {customerId}
                </span>
              )}
            </div>
            <div className="flex items-center space-x-6">
              {onBack && (
                <button
                  onClick={onBack}
                  className="caylent-body font-medium transition-colors duration-200 text-white"
                  style={{ 
                    color: 'white',
                    fontSize: '12px'
                  }}
                  onMouseEnter={(e) => (e.target as HTMLButtonElement).style.color = 'var(--caylent-light-green)'}
                  onMouseLeave={(e) => (e.target as HTMLButtonElement).style.color = 'white'}
                >
                  Back to Upload
                </button>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="bg-black text-white max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <div className="caylent-subtitle mb-2 text-white" style={{ color: 'white' }}>
            EXPORT INSTRUCTIONS
          </div>
          <h2 className="caylent-large-title mb-3 text-white" style={{ color: 'white' }}>
            Choose Your Database Platform
          </h2>
          <p className="caylent-body text-white" style={{ fontSize: '14px', color: 'white' }}>
            Select your database engine below to access detailed export instructions with step-by-step screenshots.
          </p>
        </div>

        {/* Database Instructions Menu */}
        <DatabaseInstructionsMenu />
      </main>

      {/* Footer */}
      <footer className="bg-black text-white mt-12" style={{ borderTop: '2px solid var(--caylent-light-green)' }}>
        <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <p className="caylent-body-small text-white" style={{ color: 'white', opacity: 0.7 }}>
              Database export instructions for Caylent Accelerate™ Database Modernization
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};